import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIALS]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].GET_WORK_ORDERS_MATERIAL]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/:materialId/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].CREATE_WORK_ORDERS_MATERIAL]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PUT_WORK_ORDERS_MATERIAL]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/:materialId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].PATCH_WORK_ORDERS_MATERIAL]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/:materialId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_MATERIALS].DELETE_WORK_ORDERS_MATERIAL]: {
		url: '/company/:companyId/work_orders/:workOrderId/materials/:materialId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}